const FEATURE_NAME = 'me'

const loginUserQueryKeys = {
  index: () => [FEATURE_NAME, 'loginUserData'] as const,
}

export default loginUserQueryKeys
